import { useService } from 'react-reservice';

import { copyTradeService } from '@aqx-core/common/services/copy-trade/service';

export const useCopyTradeAuth = () => {
  return useService(copyTradeService, (context) => context.isAuthenticated);
};

export const useCopyTradeAuthLoading = () => {
  return useService(copyTradeService, (context) => context.authLoading);
};

export const useCopyTradeStrategyList = () => {
  return useService(copyTradeService, (context) => context.strategyList);
};

export const useSelectedStrategySection = () => {
  return useService(copyTradeService, (context) => context.selectedStrategySection);
};

export const useDisplayStrategyList = () => {
  return useService(copyTradeService, (context) => context.displayStrategyList);
};

export const useSelectedStrategy = () => {
  return useService(copyTradeService, (context) => context.selectedStrategy);
};

export const useSelectedStrategyLoading = () => {
  return useService(copyTradeService, (context) => context.selectedStrategyLoading);
};

export const useSelectedStrategyDetail = () => {
  return useService(copyTradeService, (context) => context.selectedStrategyDetail);
};

export const useSelectedStrategyDetailLoading = () => {
  return useService(copyTradeService, (context) => context.selectedStrategyDetailLoading);
};

export const useSearchQuery = () => {
  return useService(copyTradeService, (context) => context.searchQuery);
};

export const useSelectedStrategyDetailTab = () => {
  return useService(copyTradeService, (context) => context.selectedStrategyDetailTab);
};

export const useStrategyListLoading = () => {
  return useService(copyTradeService, (context) => context.strategyListLoading);
};

export const useStrategyListLoadingMore = () => {
  return useService(copyTradeService, (context) => context.strategyListLoadingMore);
};

export const useHasMoreStrategies = () => {
  return useService(copyTradeService, (context) => context.hasMoreStrategies);
};

export const useCopyTradeUserInfoLoading = () => {
  return useService(copyTradeService, (context) => context.userInfoLoading);
};

export const useUserInfo = () => {
  return useService(copyTradeService, (context) => context.userInfo);
};

export const useStrategyImage = () => {
  return useService(copyTradeService, (context) => context.strategyImage);
};

export const useCopierId = () => {
  return useService(copyTradeService, (context) => context.selectedCopierId);
};

export const useIsLoadingCopyTradeOpenPositions = () => {
  return useService(copyTradeService, (context) => context.isLoadingCopyTradeOpenPositions);
};

export const useIsLoadingCopyTradeHistory = () => {
  return useService(copyTradeService, (context) => context.isLoadingCopyTradeHistory);
};

export const useIsLoadingCopyTradeHistoryMore = () => {
  return useService(copyTradeService, (context) => context.isLoadingCopyTradeHistoryMore);
};

export const useHasMoreCopyTradeHistory = () => {
  return useService(copyTradeService, (context) => context.hasMoreCopyTradeHistory);
};

export const useCopyTradeOpenPositions = () => {
  return useService(copyTradeService, (context) => context.copyTradeOpenPositions);
};

export const useCopyTradeHistory = () => {
  return useService(copyTradeService, (context) => context.copyTradeHistory);
};

export const useBrokers = () => {
  return useService(copyTradeService, (context) => context.brokers);
};

export const useIsLoadingServers = () => {
  return useService(copyTradeService, (context) => context.isLoadingServers);
};

export const useServers = () => {
  return useService(copyTradeService, (context) => context.servers);
};

export const useShouldShowLinkPelicanAccountModal = () => {
  return useService(copyTradeService, (context) => context.shouldShowLinkPelicanAccountModal);
};

export const useIsPrecheckingCopyStrategy = () => {
  return useService(copyTradeService, (context) => context.isPrecheckingCopyStrategy);
};

export const useIsPrecheckingEditCopyStrategy = () => {
  return useService(copyTradeService, (context) => context.isPrecheckingEditCopyStrategy);
};

export const useIsPrecheckingStopCopying = () => {
  return useService(copyTradeService, (context) => context.isPrecheckingStopCopying);
};

export const useIsPrecheckingDrawdown = () => {
  return useService(copyTradeService, (context) => context.isPrecheckingDrawdown);
};

export const useIsLoadingLinkAccountToPelicanCopyTrade = () => {
  return useService(copyTradeService, (context) => context.isLoadingLinkAccountToPelicanCopyTrade);
};

export const useIsLoadingSwitchCopier = () => {
  return useService(copyTradeService, (context) => context.isLoadingSwitchCopier);
};

export const useCopierInfo = () => {
  return useService(copyTradeService, (context) => context.copierInfo);
};

export const useIsLoadingResetCopierDrawdown = () => {
  return useService(copyTradeService, (context) => context.isLoadingResetCopierDrawdown);
};

export const useIsLoadingEditCopierDrawdown = () => {
  return useService(copyTradeService, (context) => context.isLoadingEditCopierDrawdown);
};

export const useIsLoadingRemoveCopier = () => {
  return useService(copyTradeService, (context) => context.isLoadingRemoveCopier);
};

export const useCopySettings = () => {
  return useService(copyTradeService, (context) => context.copySettings);
};

export const useIsLoadingCopySettings = () => {
  return useService(copyTradeService, (context) => context.isLoadingCopySettings);
};

export const useIsLoadingCreateCopySettings = () => {
  return useService(copyTradeService, (context) => context.isLoadingCreateCopySettings);
};

export const useIsLoadingEditCopySettings = () => {
  return useService(copyTradeService, (context) => context.isLoadingEditCopySettings);
};

export const useIsLoadingStopCopySettings = () => {
  return useService(copyTradeService, (context) => context.isLoadingStopCopySettings);
};

export const useReturnHistoryChartTimeframe = () => {
  return useService(copyTradeService, (context) => context.returnHistoryChartTimeframe);
};

export const useIsReturnHistoryChartExpanded = () => {
  return useService(copyTradeService, (context) => context.isReturnHistoryChartExpanded);
};
